import consumer from './consumer';

export default {
  subscribe(importId, callback) {
    return consumer.subscriptions.create(
      {
        channel: 'FileImportChannel',
        import_id: importId,
      },
      {
        received(data) {
          callback(data);
        },
      },
    );
  },
};
